import {IconProps} from './types';

function Clock({stroke = 'currentColor', width = 18, height = 18}: IconProps) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 16" fill="none">
            <circle cx="8" cy="8" r="6.25" stroke={stroke} />
            <path d="M8 4.5V8L10.5 9.5" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}

export default Clock;
